export default function TraditionInNumbers() {
  const stats = [{
    value: "50%",
    label: "Risparmio Idrico"
  }, {
    value: "25%",
    label: "Aumento Resa"
  }, {
    value: "100%",
    label: "Sostenibilità"
  }, {
    value: "15k+",
    label: "Ettari Trattati"
  }];
  return <section data-section-id="224059" id="limpatto-in-numeri" className="w-full bg-background text-foreground">
      <div className="w-full border-y border-border bg-muted/30 py-12 md:py-16 relative overflow-hidden">
        {}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(#5b7fa6 1px, transparent 1px), linear-gradient(90deg, #5b7fa6 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }}></div>
        
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-2 gap-8 text-center md:grid-cols-4 md:gap-12">
            {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center">
                <span className="mb-2 font-default text-5xl font-bold text-secondary tracking-tighter md:text-6xl lg:text-7xl">
                  {stat.value}
                </span>
                <span className="font-default text-sm font-semibold tracking-widest text-primary uppercase md:text-base">
                  {stat.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}